module.exports = __webpack_public_path__ + "img/gratidao.b770199c.gif";